export const STAFF_AUTH = {
  /** 一般 */
  GENERAL: 0,
  /** 外部スタッフ */
  GUST: 1,
  /** 管理者 */
  ADMIN: 2,
}
